import script from "./userSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./userSetting.vue?vue&type=script&setup=true&lang=js"

import "./userSetting.vue?vue&type=style&index=0&id=049d3ff6&lang=less"

const __exports__ = script;

export default __exports__